import { Component } from '@angular/core';

@Component({
	selector: 'mos-spinner-loader',
	standalone: true,
	templateUrl: './spinner-loader.component.html',
})
export class SpinnerLoader {}
